import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */
  static targets = ["hm0_output"];

  connect() {
    console.log("Factures Fournisseurs JS en cours ...");
    super.connect();
    var self = this;
    console.log("current app: " + this.current_app);
    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      //this.show_edition_multiple();
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });

      const currentUrl = window.location.href;
      const url = new URL(currentUrl);
      const bonsDeCommandeParam = url.searchParams.get("previous_record");

      if (bonsDeCommandeParam != null) {
        $("#factures_fournisseur_" + bonsDeCommandeParam + " td").addClass(
          "highlighted-td"
        );
        $("#factures_fournisseur_" + bonsDeCommandeParam)
          .get(0)
          .scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }


    function checkMontantMinMax() {
      let p_min = document.getElementById("filterrific_with_montant_ttc_devise_min");
      let p_max = document.getElementById("filterrific_with_montant_ttc_devise_max");
      let min = Math.abs(p_min.value * 1);
      let max = Math.abs(p_max.value * 1);
      if (min >= max) {
        max = min + 1;
        p_max.value = max;
        document.getElementById(p_max.dataset.targetIdChange).value = max;
      }
    }

    function updateRangeInput(me) {
      try {
        let target = me.dataset.targetIdChange;
        document.getElementById(target).value = me.value;
      } catch (error) {
        console.error("Null target !");
        return 1;
      }
      return 0;
    }

    function checkMontant(me, min, max) {
      if (me.value.length > 0) {
        if (me.value < min) {
          me.value = min;
        }
        if (me.value > max) {
          me.value = max;
        }
        if (updateRangeInput(me) === 1) {
          return;
        }
        checkMontantMinMax();
      }
    }

    try {
      document.getElementById("montant_ttc_devise_min").oninput = function (e) {
        let max =
          document.getElementById("real_montant_ttc_devise_max").value * 1;
        checkMontant(this, 0, max - 1);
        e.stopPropagation();
      };
      document.getElementById("montant_ttc_devise_max").oninput = function (e) {
        let max =
          document.getElementById("real_montant_ttc_devise_max").value * 1;
        checkMontant(this, 0, max);
        e.stopPropagation();
      };
      document.getElementById(
        "filterrific_with_montant_ttc_devise_min"
      ).oninput = function (e) {
        let max =
          document.getElementById("real_montant_ttc_devise_max").value * 1;
        checkMontant(this, 0, max - 1);
        e.stopPropagation();
      };
      document.getElementById(
        "filterrific_with_montant_ttc_devise_max"
      ).oninput = function (e) {
        let max =
          document.getElementById("real_montant_ttc_devise_max").value * 1;
        checkMontant(this, 1, max);
        e.stopPropagation();
      };
    } catch (error) {
      console.warn("Some ids not found ! (Possible current page is not index)");
    }

 
  
  }

  get params() {
    return this.data.get("params");
  }

  get factures_ids() {
    return this.data.get("factures_ids");
  }

  get factures_id() {
    return this.data.get("factures_id");
  }

  get current_app() {
    return this.data.get("app");
  }

  get url_solution() {
    return this.data.get("url-solution");
  }
}
